import { ClickToCallButton } from "./ClickToCallButton";
import { EmailButton } from "./EmailButton";

interface ContactButtonsProps {
  phone: string | null | undefined;
  email: string | null | undefined;
  customerName: string;
  orderId?: string;
  customerId?: string;
  orderNumber?: string;
}

export function ContactButtons({ phone, email, customerName, orderId, customerId, orderNumber }: ContactButtonsProps) {
  return (
    <div className="flex items-center gap-1">
      <ClickToCallButton phoneNumber={phone} customerName={customerName} orderId={orderId} customerId={customerId} />
      <EmailButton email={email} customerName={customerName} orderNumber={orderNumber} />
    </div>
  );
}
